import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator, fallback } from '@tanstack/zod-adapter'
import { ConversationList } from '@/components/conversations/conversation-list'

const conversationSearchSchema = z.object({
  agent_id: fallback(z.string(), '').default(''),
  status: fallback(z.string(), '').default(''),
  from: fallback(z.string(), '').default(''),
  to: fallback(z.string(), '').default(''),
  page: fallback(z.number(), 1).default(1),
  page_size: fallback(z.number(), 20).default(20),
})

export type ConversationSearch = z.infer<typeof conversationSearchSchema>

export const Route = createFileRoute('/_authenticated/conversations/')({
  validateSearch: zodValidator(conversationSearchSchema),
  component: ConversationsListPage,
})

function ConversationsListPage() {
  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-medium font-serif text-foreground mb-2">
          Conversations
        </h1>
        <p className="text-base text-muted-foreground">
          View and analyze agent conversations
        </p>
      </div>

      {/* Conversation list with integrated filters, table, pagination */}
      <ConversationList />
    </div>
  )
}
